<template>
	<div class="col-12 inMiddle-area table-responsive">
		<table class="table customize">
			<thead>
				<tr>
					<th>{{$t('accountId')}}</th>
					<th>{{$t('currency')}}</th>
					<th>{{$t('platform')}}</th>
					<th>{{$t('demoLive')}}</th>
					<th>{{$t('accountType')}}</th>
					<th>{{$t('leverage')}}</th>
					<th></th> 
				</tr>
			</thead>
			<tbody  v-if="(!pageLoader1 && liveAccountList != '' && liveAccountList.totalRecords > 0)">
				<tr class="selectHere" v-for="(list,index) in liveAccountList.records">
					<td>{{list.account_id}}</td>
					<td><img :src="'../../../../static/fxView/images/'+currency[list.currency.toUpperCase()]" class="data_currency"></td>
					<td>{{list.platform}}</td>
					<td class="text-capitalize" v-html="(parseInt(list.demo_live) == 0)? 'demo' :'live'"></td>
					<td>{{list.account_type}}</td>
					<td>{{list.leverage}}</td>
					<td width="120">
						<div class="d-flex align-items-center"> 
							<router-link @click="addFundEvent" :to="{name: 'fxView.deposit' , params: { 'account_id':list.account_id , 'act_account_id' : list.act_account_id, 'currency': list.currency.toUpperCase()}}" class="prism_btn titleBG btn_xs">{{$t('addFund')}}</router-link>
							
							<div class="position-relative ml-3">
								<span class="tableoption dotAreaForButton" @click="detailDiv(index,'buttons',list.account_id,list.act_account_id)"><feather type="more-horizontal" size="1rem"></feather></span>								
								<div class="tablefilter box-shadow"  :ref="'buttons'+index" v-if="parseInt(showButtonDetailInfo) == index">
									 <ul>
										<li>
											<router-link :to="{name: 'fxView.changeLeverage' , params: { 'account_id':list.account_id, 'leverage':list.leverage, 'act_account_id' : list.act_account_id , 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('changeLeverage')}}</router-link>
										</li>
										<li>
											<router-link :to="{name: 'fxView.changePassword' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('changePassword')}}</router-link>
										</li>
										<li>
											<router-link :to="{name: 'fxView.internalTransfer' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform , 'from_currency': list.currency}}">{{$t('internalTransfer')}}</router-link>
										</li>
										<li>
											<a title="Act Web Trader Live" href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245" target="_blank" v-if="(list.platform == 'ACT' || list.platform == 'ACT-ZULU')">{{$t('tradeNow')}}</a>
											<router-link :to="'/new-web-trade-link'" target="_blank" v-else-if="(list.platform.toUpperCase() == 'MT4')">{{$t('tradeNow')}}</router-link>
											<router-link :to="{path : '/web-trade-link',query :{'platform' : list.platform}}" target="_blank" v-else>{{$t('tradeNow')}}</router-link>
										</li>
									 </ul>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
			<loader-component :pageloader_value="pageLoader1" :type="'table'" :colspan="col_span" :list="liveAccountList" v-else></loader-component>
		</table> 
		<!--<pagination :getList="manageAccountList" :limit="pageLimit" v-if="manageAccountList.totalRecords > 0"></pagination>-->
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Live-Account-List',
        mixins: [fxViewMixins],
        data() {
            return { 
                //===========prop in loader component=======
                col_span : 7,
				showButtonDetailInfo : ''
            }
        },
		props:['pageLoader1'],
        methods:{
        	detailDiv(index,getData,account_id,act_account_id) {
				if(getData == 'div'){
					if ($(this.$refs[getData+index]).hasClass('hide')){
						$(this.$refs[getData+index]).removeClass('hide');
					}else{
						$(this.$refs[getData+index]).addClass('hide');
					} 
				}else{
					if(parseInt(this.showButtonDetailInfo) == index){
						this.showButtonDetailInfo = ''
					}else{
						this.showButtonDetailInfo = index
					}
				}
            },
			addFundEvent(){
				this.$trackEvent('CP+Account+Add+Funds');
			}
        	
		},
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.dotAreaForButton').length){
                    _that.showButtonDetailInfo = ''
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/live_account_list.vue